import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['otherRadio', 'radio', 'textfieldWrapper'];

  otherRadioTargetConnected(radio) {
    radio.addEventListener('ionChange', (event) => {
      this.hideTextFields();
      this.showTextField(event.target);
    });
  }

  radioTargetConnected(radio) {
    radio.addEventListener('ionChange', (event) => {
      this.hideTextFields();
    });
  }

  showTextField(radio) {
    this.textfieldWrapperTarget.classList.remove('display-none');
  }

  hideTextFields() {
    this.element.parentElement
      .querySelectorAll('.text-field-wrapper')
      .forEach((wrapper) => {
        wrapper.classList.add('display-none');
        wrapper.querySelector('ion-input[type="text"]').value = '';
      });
  }
}
